import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CustomTimeRangeCategory } from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'

interface Props {
  category: CustomTimeRangeCategory
}

const ArchivedItem = ({ category }: Props) => {
  const { name } = category

  const timeTypeCopy = category.isRegular
    ? i18n.t('time_categories.regular')
    : i18n.t('time_categories.overtime')

  return (
    <Box
      flexDirection="row"
      gap="s16"
      alignItems="flexStart"
      justifyContent="spaceBetween"
      width="full"
      component="li"
    >
      <Box flexDirection="row" gap="s6" justifyContent="flexStart" alignItems="center">
        <Text size="300" color="grey800" weight="medium" ellipsis>
          {name}
        </Text>
        <Text size="300" color="grey800" weight="medium">
          ･
        </Text>
        <Text size="300" color="grey800" weight="medium" whiteSpace="nowrap">
          {timeTypeCopy}
        </Text>
      </Box>
      <Box justifyContent="flexEnd">
        <Text size="200" whiteSpace="nowrap">
          {i18n.t('time_categories.card_description', {
            rawMinutes: category.rawMinutes,
            equivalentMinutes: category.equivalentMinutes,
          })}
        </Text>
      </Box>
    </Box>
  )
}

export default ArchivedItem
